import type { PhotoCache } from "./photoCache.types";

export type { PhotoCache } from "./photoCache.types";

export const photoCache: PhotoCache = {
    getOrLoad: (_key, loader) => loader(),
    clear: async () => {},
};
